import { dismissDocViewer, useDocViewer } from '../../../lib/doc-viewer-presenter';
import { DocViewerModal } from './DocViewerModal';

/**
 * The ONE place the document viewer is rendered — the web equivalent of native hosting
 * `DocumentViewer` once in `RootView.swift`'s overlay chain / `AppRoot.kt`'s ZStack.
 *
 * Mounted by `SymphonyApp`, OUTSIDE its framed/chrome-free branch, so it sits above every page and
 * outlives any row, panel or side panel that opens it (see `lib/doc-viewer-presenter.ts` for the defect
 * that motivates it). No call site renders `DocViewerModal` itself; they all call `openDocViewer(...)`.
 *
 * `key={id}` so a second open of the same file starts a fresh modal (query + scroll state reset) rather
 * than reusing the instance the user just closed.
 */
export function DocViewerHost() {
  const request = useDocViewer();
  if (!request) return null;
  return (
    <DocViewerModal
      key={request.id}
      file={request.file}
      kind={request.kind}
      pageName={request.pageName}
      fileHref={request.fileHref}
      workspaceName={request.workspaceName}
      onClose={dismissDocViewer}
    />
  );
}
